<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />

    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="mb-3 p-3 bg-light border rounded">
            <strong>عنوان:</strong> {{ notice.title || ' - ' }}
            <br />
            <strong>نوع:</strong> {{ notice.notice_type === 'tender' ? 'مناقصه' : 'مزایده' }}
          </div>

          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>

<script>
import noticesApi from '../../../api/tender/noticesApi';
import bidsApi from '../../../api/tender/bidsApi';

export default {
  data() {
    return {
      pageSize: 15,
      currentPage: 1,
      isLoadingGrid: false,
      notice: {},
      rows: [],
      breadCrumbs: [
        { title: 'صفحه اصلی', link: '/' },
        { title: 'لیست قیمت‌ها', link: '/admin/closed-notices', active: false },
      ],
    };
  },

  computed: {
    gridColumns() {
      return [
        { field: 'supplier_name', title: 'تامین‌کننده' },
        { field: 'bid_amount_text', title: 'قیمت پیشنهادی' },
        { field: 'submitted_at_text', title: 'تاریخ ثبت' },
        { field: 'status_text', title: 'وضعیت' },
      ];
    },
  },

  mounted() {
    this.loadNotice();
  },

  methods: {
    loadNotice() {
      const id = this.$route.params.id;

      noticesApi.show(id).then(({ data }) => {
        this.notice = data.data || data;
      });
    },

    formatSupplier(supplier) {
      if (!supplier) return ' - ';

      if (supplier.company_name) {
        return supplier.company_name;
      }

      const fullName = `${supplier.first_name || ''} ${supplier.last_name || ''}`.trim();
      return fullName || ' - ';
    },

    formatMoney(value) {
      const n = Number(value || 0);
      return this.$thousandSeprator(this.$round(n));
    },

    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;

      const id = this.$route.params.id;

      bidsApi.getByNotice(id, {
        page_size: e.data.pageSize,
        page: e.data.page,
      })
      .then(({ data }) => {
        const payload = data.data || data;
        const list = payload.data || payload;

        const mapped = list.map((item) => ({
          ...item,
          supplier_name: this.formatSupplier(item.supplier),
          bid_amount_text: this.formatMoney(item.bid_amount),
          submitted_at_text: item.submitted_at ? this.$getJalaliDate(item.submitted_at) : ' - ',
          status_text: item.status || ' - ',
        }));

        e.success({
          ...payload,
          data: mapped,
        });
      })
      .catch(() => {
        e.success({ data: [], total: 0 });
      })
      .finally(() => {
        this.isLoadingGrid = false;
      });
    },
  },
};
</script>